// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"184":"c6ffdb20","953":"f9a8cd96","991":"53858ce9"}[chunkId] + ".css";
};